// import React, { useState, useEffect } from "react";
// import axios from "axios";

// import {
//   RadialBarChart,
//   RadialBar,
//   Tooltip,
//   ResponsiveContainer,
// } from "recharts";


// import { BASE_URL } from "../../../config/axios";


// const LeaveChart = ({ emp_code }) => {


//   const [statData, setStatData] = useState({});
//   const getStatdata = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/wfm/requestsapplied/${emp_code}/`);
//       console.log(res.data)
//       setStatData(res.data);
//     } catch (err) {
//       alert(err.message);
//     }
//   };

//   const [graphData, setGraphData] = useState({});
//   const getGraphdata = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/wfm/requeststatus/${emp_code}/`);
//       console.log(res.data)
//       setGraphData(res.data);
//     } catch (err) {
//       alert(err.message);
//     }
//   };


//   useEffect(() => {
//     getStatdata();
//     getGraphdata();
//   }, []);

//   const data = [
//     {
//       name: "Short Day Leave",
//       uv: statData.leave_shortleave,
//       fill: "#165DFF",
//     },
//     {
//       name: "HalfDay Leave",
//       uv: statData.leave_halfdayleave,
//       fill: "#F7BA1E",
//     },
//     {
//       name: "Single Day Leave",
//       uv: statData.leave_single,
//       fill: "#FF747C",
//     },
//     {
//       name: "Multi Day Leave",
//       uv: statData.leave_multiple,
//       fill: "#30C9C9",
//     },
//   ];

//   return (
//     <ResponsiveContainer width="90%" height={205} className="radialchart">
//       <div className="leavechart-heading">
//         <div className="repo-heading-a font-weight500   font-size-subheading">Total Leaves -  {statData.allleave}</div>
//         <div>
//           {data.map((item) => {
//             return (
//               <div key={item.name} className="radialchart-legend">
//                 <div
//                   className="radialchart-dot"
//                   style={{ backgroundColor: item.fill }}
//                 ></div>
//                 <div className="radialchart-subheading font-weight600  font-size-text ">
//                   {item.name} - {item.uv}
//                 </div>
//               </div>
//             );
//           })}
//         </div>

//       </div>

//       <RadialBarChart
//         innerRadius={30}
//         outerRadius={125}
//         barSize={13}
//         startAngle={90}
//         endAngle={450}
//         data={data}
//       >
//         <RadialBar
//           minAngle={15}
//           background
//           clockWise="true"
//           cornerRadius={10}
//           dataKey="uv"
//         ></RadialBar>
//         {/* <Tooltip /> */}
//       </RadialBarChart>
//     </ResponsiveContainer>
//   );
// };

// export default LeaveChart;

import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  RadialBarChart,
  RadialBar,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import { BASE_URL } from "../../../config/axios";

const LeaveChart = ({ emp_code }) => {
  const [statData, setStatData] = useState({});

  const getStatdata = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/wfm/requestsapplied/${emp_code}/`);
      setStatData(res.data);
    } catch (err) {
      alert(err.message);
    }
  };

  const [graphData, setGraphData] = useState({});

  const getGraphdata = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/wfm/requeststatus/${emp_code}/`);
      setGraphData(res.data);
    } catch (err) {
      alert(err.message);
    }
  };

  useEffect(() => {
    getStatdata();
    getGraphdata();
  }, []);

  // Added "|| 0" fallbacks so the chart doesn't break while the API is loading
  const data = [
    {
      name: "Short Day Leave",
      uv: statData.leave_shortleave || 0,
      fill: "#165DFF",
    },
    {
      name: "HalfDay Leave",
      uv: statData.leave_halfdayleave || 0,
      fill: "#F7BA1E",
    },
    {
      name: "Single Day Leave",
      uv: statData.leave_single || 0,
      fill: "#FF747C",
    },
    {
      name: "Multi Day Leave",
      uv: statData.leave_multiple || 0,
      fill: "#30C9C9",
    },
  ];

  return (
    // 1. The Main Wrapper
    <div
      className="radialchart-wrapper"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        gap: '20px' // Keeps them from overlapping when stacked
        // REMOVED height: '100%' so it can expand vertically when wrapped
      }}
    >
      {/* 2. Left Legend */}
      <div className="leavechart-heading" style={{ flex: '1 1 150px', minWidth: '150px' }}>
        <div className="repo-heading-a font-weight500 font-size-subheading" style={{ marginBottom: '15px' }}>
          Total Leaves - {statData.allleave || 0}
        </div>
        <div>
          {data.map((item) => {
            return (
              <div key={item.name} className="radialchart-legend" style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <div
                  className="radialchart-dot"
                  style={{ backgroundColor: item.fill, width: '12px', height: '12px', borderRadius: '50%', marginRight: '8px' }}
                ></div>
                <div className="radialchart-subheading font-weight600 font-size-text">
                  {item.name} - {item.uv}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* 3. Right Chart Container */}
      <div className="chart-mobile-wrapper">

        {/* THE FIX: Use a hardcoded pixel height here. It guarantees the chart will never collapse to 0px! */}
        <ResponsiveContainer width="100%" height="100%">

          <RadialBarChart
            cx="50%"
            cy="50%"
            innerRadius="30%"
            outerRadius="85%" /* Changed from 100% to 85% to stop edge clipping */
            barSize={13}
            startAngle={90}
            endAngle={450}
            data={data}
          >
            <RadialBar
              minAngle={15}
              background
              clockWise={true}
              cornerRadius={10}
              dataKey="uv"
            />
          </RadialBarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default LeaveChart;